import api from './api';

export const getUsers = async (skip = 0, limit = 10) => {
  const response = await api.get('/users', {
    params: { skip, limit },
  });
  return response.data;
};

export const getUser = async (userHash) => {
  const response = await api.get(`/users/${userHash}`);
  return response.data;
};

export const createUser = async (userData) => {
  const response = await api.post('/users', userData);
  return response.data;
};

export const updateUser = async (userHash, userData) => {
  const response = await api.put(`/users/${userHash}`, userData);
  return response.data;
};

export const deleteUser = async (userHash) => {
  const response = await api.delete(`/users/${userHash}`);
  return response.data;
};
